import React, {createContext, useReducer} from 'react'
import {DepartReducer} from "../reducers/DepartReducer";

export const DepartContext = createContext()

const DepartContextProvider = (props) => {
    const state = {
        totalRoute: 0,
        partialDepartedRoutes: 0,
        departedRoutes: 0,
        routeList: [],
        lastUpdated: null,
        alert: {},
        bulkDepartStatus: null
    }
    const [ viewModel, dispatch ] = useReducer(DepartReducer, state);
    return (
        <DepartContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </DepartContext.Provider>
    )
}

export default DepartContextProvider


// WEBPACK FOOTER //
// ./src/components/depart/context/DepartContext.js